export { default } from "./InputTable";
